module.exports = __webpack_public_path__ + "img/page_image_1_2.04bbaff8.svg";